import { Box, Spinner } from '@chakra-ui/react';

type LoadingSpinnerProps = {
    size?: number;
    color?: string;
    container?: boolean;
};

export const LoadingSpinner = ({
    size,
    color = '#000',
    container = true,
}: LoadingSpinnerProps) => {
    return (
        <Box
            display={container ? 'flex' : undefined}
            justifyContent={container ? 'center' : undefined}
            alignItems={container ? 'center' : undefined}
            height={container ? '50vh' : undefined}
        >
            <Spinner
                speed="1s"
                emptyColor="transparent"
                color={color}
                size={size ? `${size}px` : undefined}
            />
        </Box>
    );
};
